import {
  Box,
  Flex,
  Heading,
  Text,
  VStack,
  Icon,
  Button,
  useColorModeValue,
} from "@chakra-ui/react";
import { ChatIcon } from "@chakra-ui/icons";
import { motion } from "framer-motion";

const MotionBox = motion(Box);

export default function TeamChatComingSoon() {
  const bg = useColorModeValue("gray.50", "gray.900");
  const gradient = useColorModeValue(
    "linear(to-r, green.500, teal.400)",
    "linear(to-r, green.400, teal.500)"
  );

  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      h="100vh"
      bg={bg}
      textAlign="center"
      px={6}
    >
      <VStack spacing={8}>
        <MotionBox
          animate={{ y: [0, -10, 0] }}
          transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
        >
          <Icon as={ChatIcon} boxSize={20} color="green.500" />
        </MotionBox>

        <VStack spacing={3}>
          <Heading
            bgGradient={gradient}
            bgClip="text"
            fontSize={{ base: "3xl", md: "4xl" }}
            fontWeight="extrabold"
          >
            Team Chat Coming Soon
          </Heading>
          <Text fontSize={{ base: "md", md: "lg" }} color="gray.500" maxW="lg">
            We’re building a powerful internal chat for your team so you can
            collaborate, share updates, and close deals faster, right inside
            your CRM.
          </Text>
        </VStack>

        <Button
          size="lg"
          colorScheme="green"
          variant="solid"
          onClick={() => window.history.back()}
        >
          Go Back
        </Button>

        <Text fontSize="sm" color="gray.400">
          Stay tuned - this feature will launch soon!
        </Text>
      </VStack>
    </Flex>
  );
}
